module.exports = __webpack_public_path__ + "images/1fa739dc28cfb109320cf32dae5910a1-green.png";